<template>
  <PopupBackground v-if="showComputedPropertyCreationPopup">
    <div class="generic-popup smooth-shadow">
      <!-- Header -->
      <div class="header">
        <div class="title">
          <h3>New Computed Layer</h3>
          <p>Create property layers based on mathematical expressions</p>
        </div>
      </div>
      <!-- Contents -->
      <div class="contents">
        <label>Layer Name</label>
        <input
          v-model="layerName"
          type="text"
          placeholder="Enter your layer name"
        />
        <label>Calculation Formula</label>
        <FormulaInput
          v-model="expression"
          :options="getProperties"
          @eval="setExpressionValue"
        />
        <p class="representation">
          {{ representation ? `ƒx = ${representation}` : "" }}
        </p>
      </div>

      <!-- Footer -->
      <div class="footer">
        <expand />
        <Button type="cancel" @click="toggleComputedPropertyCreationPopup()" />
        <Button
          type="save"
          @click="createComputedProp()"
          :disabled="isButtonDisabled"
        />
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Button from "@/components/metrics/views/Button";
import FormulaInput from "@/components/metrics/views/FormulaInput";
import { mapActions, mapGetters } from "vuex";
import { ComputedLayer } from "../../../models/Layers.model";
export default {
  components: {
    PopupBackground,
    Button,
    FormulaInput,
  },
  data() {
    return {
      layerName: "",
      expression: "",
      variables: [],
      finalExp: "",
      isValid: false,
      representation: "",
    };
  },
  computed: {
    ...mapGetters("Popup", ["showComputedPropertyCreationPopup"]),
    ...mapGetters("LayerManager", ["getProperties"]),
    isButtonDisabled() {
      if (this.layerName && this.isValid && this.variables && this.finalExp) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions("Popup", ["toggleComputedPropertyCreationPopup"]),
    ...mapActions("LayerManager", ["addComputedProp"]),
    createComputedProp() {
      const layer = new ComputedLayer({
        name: this.layerName,
        variables: this.variables,
        expression: this.finalExp,
        description: this.representation,
      });

      this.addComputedProp(layer);
      this.toggleComputedPropertyCreationPopup();
    },
    setExpressionValue(data) {
      if (data.isValid) {
        this.isValid = true;
        this.variables = data.variables;
        this.finalExp = data.expression;
        this.representation = data.representation;
      } else {
        this.isValid = false;
        this.variables = [];
        this.finalExp = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.generic-popup {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 450px;

  .header,
  .footer,
  .contents {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;

    .title {
      display: flex;
      flex-direction: column;

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.5;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: column;
    padding: 15px;

    label {
      margin: 0 0 5px 0;
    }
    input {
      margin: 0 0 10px 0;
    }

    .representation {
      margin: 0;
      padding: 10px 0;
      color: var(--color-primary);
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
